import { Package, Truck, CheckCircle, Clock, UploadCloud } from 'lucide-react';


const TransportStats = ({ stats }) => {
  return (
    <div className="grid grid-cols-2 lg:grid-cols-5 gap-3">
      {/* Total */}
      <div className="bg-white p-3 rounded-xl shadow-sm border border-gray-100">
        <div className="flex items-center justify-between">
          <div>
            <p className="text-xs font-medium text-gray-500">Total</p>
            <p className="text-xl font-bold text-gray-900">{stats.total}</p>
          </div>
          <div className="w-8 h-8 bg-gray-100 rounded-lg flex items-center justify-center">
            <Package className="w-4 h-4 text-gray-600" />
          </div>
        </div>
      </div>

      {/* În tranzit */}
      <div className="bg-white p-3 rounded-xl shadow-sm border border-gray-100">
        <div className="flex items-center justify-between">
          <div>
            <p className="text-xs font-medium text-gray-500">În tranzit</p>
            <p className="text-xl font-bold text-blue-600">{stats.inTransit}</p>
          </div>
          <div className="w-8 h-8 bg-blue-50 rounded-lg flex items-center justify-center">
            <Truck className="w-4 h-4 text-blue-600" />
          </div>
        </div>
      </div>

      {/* Finalizate */}
      <div className="bg-white p-3 rounded-xl shadow-sm border border-gray-100">
        <div className="flex items-center justify-between">
          <div>
            <p className="text-xs font-medium text-gray-500">Finalizate</p>
            <p className="text-xl font-bold text-emerald-600">{stats.completed}</p>
          </div>
          <div className="w-8 h-8 bg-emerald-50 rounded-lg flex items-center justify-center">
            <CheckCircle className="w-4 h-4 text-emerald-600" />
          </div>
        </div>
      </div>

      {/* În așteptare */}
      <div className="bg-white p-3 rounded-xl shadow-sm border border-gray-100">
        <div className="flex items-center justify-between">
          <div>
            <p className="text-xs font-medium text-gray-500">În așteptare</p>
            <p className="text-xl font-bold text-amber-600">{stats.pending}</p>
          </div>
          <div className="w-8 h-8 bg-amber-50 rounded-lg flex items-center justify-center">
            <Clock className="w-4 h-4 text-amber-600" />
          </div>
        </div>
      </div>

      {/* În încărcare */}
      <div className="bg-white p-3 rounded-xl shadow-sm border border-gray-100">
        <div className="flex items-center justify-between">
          <div>
            <p className="text-xs font-medium text-gray-500">În încărcare</p>
            <p className="text-xl font-bold text-purple-600">{stats.inLoading}</p>
          </div>
          <div className="w-8 h-8 bg-purple-50 rounded-lg flex items-center justify-center">
            <UploadCloud className="w-4 h-4 text-purple-600" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default TransportStats;